import { fetchAuthedApiResponse } from './http';

function detail(path: string, signal?: AbortSignal): Promise<Response> {
  return fetchAuthedApiResponse(path, { cache: 'no-store', signal, skipDedupe: true });
}

export interface ReceptionWorkflowScopeResponse {
  employee_id: number | null;
  employee_branch: string | null;
  allowed_branches: string[];
  can_select_all_branches: boolean;
  language_only: boolean;
  general_manager: boolean;
}

export function fetchReceptionWorkflowScopeResponse(signal?: AbortSignal): Promise<Response> {
  return detail('/reception/api/workflow-scope', signal);
}

export function fetchReceptionRequestDetailResponse(id: number, signal?: AbortSignal): Promise<Response> {
  return detail(`/reception/api/requests/${id}`, signal);
}

export function fetchReceptionCourseInterestDetailResponse(id: number, signal?: AbortSignal): Promise<Response> {
  return detail(`/reception/api/course-interests/${id}`, signal);
}

export async function convertReceptionCourseInterestResponse(
  id: number,
  groupId: number,
  note?: string,
): Promise<Response> {
  const form = new FormData();
  form.set('group_id', String(groupId));
  if (note?.trim()) form.set('note', note.trim().slice(0, 500));
  return fetchAuthedApiResponse(`/reception/api/course-interests/${id}/convert`, {
    method: 'POST',
    body: form,
  });
}

export function fetchReceptionSalesConsultationSlotDetailResponse(
  id: number,
  signal?: AbortSignal,
): Promise<Response> {
  return detail(`/reception/api/sales-consultation-slots/${id}`, signal);
}

export function fetchReceptionSalesConsultQueueDetailResponse(
  id: number,
  signal?: AbortSignal,
): Promise<Response> {
  return detail(`/reception/api/sales-consult-queue/${id}`, signal);
}

export function fetchReceptionDailyReportDetailResponse(id: number, signal?: AbortSignal): Promise<Response> {
  return detail(`/reception/api/daily-reports/${id}`, signal);
}

export function fetchReceptionSuperLogDetailResponse(id: number, signal?: AbortSignal): Promise<Response> {
  return detail(`/reception/api/super/logs/${id}`, signal);
}
